var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroupSalesCount = function SvgGroupSalesCount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#20BDE0",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeDasharray: "0,0",
    strokeWidth: 0.5,
    d: "M19.95 10.99H9.31a.56.56 0 0 0-.56.56v10.64c0 .31.25.56.56.56h10.64c.31 0 .56-.25.56-.56V11.55a.56.56 0 0 0-.56-.56Zm-.7 10.5h-9.24v-9.24h9.24zm2.94-12.74H11.41a.14.14 0 0 0-.14.14v.98c0 .077.063.14.14.14h10.08v10.08c0 .077.063.14.14.14h.98a.14.14 0 0 0 .14-.14V9.31a.56.56 0 0 0-.56-.56Zm-10.15 7.665h5.18v1.12h-5.18z"
  }))));
};
export default SvgGroupSalesCount;